import { MdWbSunny, MdOutlineSolarPower, MdAccessTime, MdPeople } from 'react-icons/md';

const counter = [
    {
        id: 1,
        icon: <MdWbSunny />, // Sun icon for Solar Projects
        title: 'Solar Projects',
        count: '150',
    },
    {
        id: 2,
        icon: <MdOutlineSolarPower />, // Solar power icon for Installed Capacity
        title: 'Installed Capacity (MW)',
        count: '1200',
    },
    {
        id: 3,
        icon: <MdAccessTime />, // Clock icon for Years of Experience
        title: 'Years of Experience',
        count: '25',
    },
    {
        id: 4,
        icon: <MdPeople />, // People icon for Satisfied Clients
        title: 'Satisfied Clients',
        count: '5000',
    },
];

export default counter;